import { Component } from 'src/utils';
import newOrderImg from './../../../images/new-order.png';
import recentOrderImg from './../../../images/recent-order.png';
import favoriteImg from './../../../images/favorites.png';
import subscriptionImg from './../../../images/subscribe.png';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import template from './navigation-bar.html';

@Component({
  controllerAs: 'navBar',
  template
})

export default class NavBarContainer {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    'authService',
    '$uibModal',
    '$cookies',
    '$stateParams',
    '$window',
    'APP'
  ];

  constructor($scope, $ngRedux, $state, toaster, $auth, $uibModal, $cookies, $window, $stateParams, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.newOrderImg = newOrderImg;
    this.recentOrderImg = recentOrderImg;
    this.favoriteImg = favoriteImg;
    this.subscriptionImg = subscriptionImg;
    this.toaster = toaster;
    this.$uibModal = $uibModal;
    this.$auth = $auth;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;
    let guestStore = null;
    if ($auth.isGuestLogin()) {
      try {
        guestStore = sessionStorage.getItem('guestStoreName');
      }
      catch (e) {
        guestStore = $cookies.get('guestStoreName');
      }
      if (!this.profile.store) {
        this.$auth.getStoreDetail(guestStore);
      }

      $scope.$on('$destroy', disconnect);
    }
  }

  mapState(state) {

    let obj = {
      profile: state.auth.profile,
      list: state.order.categories
    };
    if (!obj.profile.store) {
      obj.profile = {'store': state.auth.storeDetail};
    }
    return obj;
  }

  openToast() {
    this.toaster.pop('success', 'This Feature will be available soon');
  }

  navigateToHome() {
    if (this.$state.current.name !== 'category') {
      this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName});
    }
    else {
      this.toaster.pop('success', 'Choose category');
    }
  }

  navigateToRecentOrder() {

    if (this.$auth.isGuestLogin()) {
      var msg = 'access this';
      this.$auth.showLoginPopUp(msg);
    }
    else {
      if (this.$state.current.name !== 'recent-order') {
        this.$state.go('recent-order');
      }
      else {
        this.toaster.pop('success', 'Already on orders page');
      }
    }
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.obj.profile.store && this.obj.profile.store.storeName) {
        storeName = this.obj.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  navigateToSubscriptions(){
    if (this.$auth.isGuestLogin()) {
      var msg = 'access this';
      this.$auth.showLoginPopUp(msg);
    }
    else {
      if (this.$state.current.name !== 'subscription') {
        if(this.profile.store.isSubscription===true){
        this.$state.go('subscription'); }
        else{
          this.toaster.pop('success', 'Subscription is not Available For this store');
        }
      }
      else {
        this.toaster.pop('success', 'Already on subscription page');
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/navigation-bar/navigation-bar.js